import { createRoutine } from 'redux-saga-routines';

import {
  GET_FESTIVAL,
  GET_PERFORMANCES,
  GET_FESTIVAL_CONTACTS,
  SET_FESTIVAL,
  ADD_AND_UPDATE_FESTIVAL_CONTACTS,
  UPDATE_FESTIVAL_INFO,
  CLEAR_FESTIVAL_PRODUCTIONS,
  UPDATE_FESTIVAL,
  GET_COMPANIES,
  GET_FESTIVAL_DESCRIPTIONS,
  CREATE_FESTIVAL_DESCRIPTIONS,
  DELETE_FESTIVAL_DESCRIPTIONS,
  UPDATE_FESTIVAL_DESCRIPTIONS,
  GET_FESTIVAL_VENUES,
  UPDATE_FESTIVAL_VENUES,
  SET_INIT_PRODUCTIONS,
} from './constants';

export const getFestivalAction = createRoutine(GET_FESTIVAL);
export const getFestivalContactsAction = createRoutine(GET_FESTIVAL_CONTACTS);
export const getFestivalProductionsAction = createRoutine(GET_PERFORMANCES);
export const updateFestivalAction = createRoutine(UPDATE_FESTIVAL);
export const getCompaniesAction = createRoutine(GET_COMPANIES);
export const getFestivalDescriptionsAction = createRoutine(GET_FESTIVAL_DESCRIPTIONS);
export const createFestivalDescriptionAction = createRoutine(CREATE_FESTIVAL_DESCRIPTIONS);
export const deleteFestivalDescriptionAction = createRoutine(DELETE_FESTIVAL_DESCRIPTIONS);
export const updateFestivalDescriptionAction = createRoutine(UPDATE_FESTIVAL_DESCRIPTIONS);
export const updateFestivalInfoAction = createRoutine(UPDATE_FESTIVAL_INFO);
export const addAndUpdateFestivalContactsAction = createRoutine(ADD_AND_UPDATE_FESTIVAL_CONTACTS);
export const getFestivalVenuesAction = createRoutine(GET_FESTIVAL_VENUES);
export const updateFestivalVenueAction = createRoutine(UPDATE_FESTIVAL_VENUES);

export const setFestival = festival => ({
  type: SET_FESTIVAL,
  payload: festival,
});

export const setInitProductions = (data, query) => ({
  type: SET_INIT_PRODUCTIONS,
  payload: { data, query },
});

export const clearFestivalProductions = () => ({
  type: CLEAR_FESTIVAL_PRODUCTIONS,
  payload: {},
});
